module.exports = __webpack_public_path__ + "static/media/stage1.1e810c0b.webp";